import { useCallback } from 'react';

/**
 * Provide available types to help describe the actions being performed within the form.
 */
export enum validationMode {
  Create,
  Edit,
}

export const useYupValidationResolver = (validationSchema: any) =>
  useCallback(
    async (data) => {
      try {
        const values = await validationSchema.validate(data, {
          abortEarly: false,
        });

        return {
          values,
          errors: {},
        };
      } catch (errors: any) {
        return {
          values: {},
          errors: errors.inner.reduce(
            (allErrors: any, currentError: any) => ({
              ...allErrors,
              [currentError.path]: {
                type: currentError.type ?? 'validation',
                message: currentError.message,
              },
            }),
            {}
          ),
        };
      }
    },
    [validationSchema]
  );

export const validationMessages = {
  required: 'This field is required',
  number: 'Number must be specified',
  integer: 'Number must be a whole number',
  greaterThanZero: 'Number must be greater than 0',
  date: 'Date must be valid',
  notEmpty: 'This field cannot be empty',
  benchmarkNameNotEmpty: "Benchmark name can't be empty.",
  numberTooLarge: 'Number is too large',
  notExceed350: 'Must not exceed 350 characters',
};

export const validationValues = {
  maxInteger: 2147483647,
};
